import { API_BASE_URL } from './baseQuery';

interface UploadOptions {
  file: File;
  type?: string;
}

export async function uploadFile(
  fileOrOptions: File | UploadOptions,
  type: string = 'cms'
): Promise<{ url: string; filename: string }> {
  const file = fileOrOptions instanceof File ? fileOrOptions : fileOrOptions.file;
  const uploadType =
    fileOrOptions instanceof File ? type : fileOrOptions.type || type;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', uploadType);

  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/uploads`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Upload failed');
  }

  return response.json();
}
